import React from "react";
import { Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import useHighlightNotes from "./plugins/useHighlightNotes.js";
import jumpToPagePlugin from "./plugins/JumpToPagePlugin.js";

const PDFViewer = ({ doc }) => {
  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          CurrentPageInput,
          Download,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          Print,
          NumberOfPages,
          Rotate,
          ShowSearchPopover,
          Zoom,
          ZoomIn,
          ZoomOut,
        } = slots;
        return (
          <div
            style={{
              alignItems: "center",
              display: "flex",
              width: "100%",
              padding: "0 10px",
            }}
          >
            <div style={{ padding: "0px 2px" }}>
              <ShowSearchPopover />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomOut />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Zoom />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomIn />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <GoToPreviousPage />
            </div>
            <div style={{ padding: "0px 1px", width: "5%" }}>
              <CurrentPageInput />
            </div>
            /
            <div style={{ padding: "0px 2px" }}>
              <NumberOfPages />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <GoToNextPage />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <EnterFullScreen />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Print />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Download />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Rotate />
            </div>
          </div>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) =>
      defaultTabs.filter((tab) => {
        return (
          tab.title !== "Bookmark" &&
          tab.title !== "Attachment" &&
          tab.title !== "Thumbnail"
        );
      }),
    renderToolbar,
    toolbarPlugin: {
      fullScreenPlugin: {
        onEnterFullScreen: (zoom) => {
          zoom(SpecialZoomLevel.PageWidth);
        },
        onExitFullScreen: (zoom) => {
          zoom(SpecialZoomLevel.PageWidth);
        },
      },
    },
  });

  const jumpToPagePluginInstance = jumpToPagePlugin();
  const { highlightPluginInstance } = useHighlightNotes();

  return (
    <div className={"pdf-viewer w-full bg-white "}>
      <Viewer
        fileUrl={doc}
        defaultScale={SpecialZoomLevel.PageWidth}
        plugins={[
          defaultLayoutPluginInstance,
          highlightPluginInstance,
          jumpToPagePluginInstance,
        ]}
      />
    </div>
  );
};

export default PDFViewer;
